import { avatarDefault, imgUser } from '@/assets/images';
import { colors, guardianColors } from '@/theme/colors';
import type { UpcomingWeekItem } from './types';

// TODO: Replace with backend data once the booking/session endpoint is ready.
export const MOCK_UPCOMING_WEEK_ITEMS: UpcomingWeekItem[] = [
  {
    id: 'monday-church',
    day: 'Mon',
    date: '15',
    title: 'Tournament',
    playerName: 'Church',
    playerAvatar: imgUser,
    accentColor: guardianColors['Main/Main'],
  },
  {
    id: 'monday-lucas',
    day: 'Mon',
    date: '15',
    title: 'Tournament',
    playerName: 'Lucas',
    playerAvatar: avatarDefault,
    accentColor: guardianColors['Main/Main'],
  },
  {
    id: 'thursday-church',
    day: 'Thu',
    date: '18',
    title: 'Practice',
    playerName: 'Church',
    playerAvatar: imgUser,
    accentColor: colors.Red,
  },
  {
    id: 'sunday-church',
    day: 'Sun',
    date: '21',
    title: 'Tournament',
    playerName: 'Church',
    playerAvatar: imgUser,
    accentColor: guardianColors['Main/Main'],
  },
  {
    id: 'sunday-lucas',
    day: 'Sun',
    date: '21',
    title: 'Tournament',
    playerName: 'Lucas',
    playerAvatar: avatarDefault,
    accentColor: guardianColors['Main/Main'],
  },
];
